import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  public hideSideMenu: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() { }

  hideSideMenu$(): Observable<boolean> {
    return this.hideSideMenu.asObservable();
  }
}
